/**
 * @generated SignedSource<<f9a8c028e91dea91d53c728610a03e72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodSelectedPending_charge$data = {
  readonly availablePaymentMethods: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodPaymentDeadline_charge" | "PaymentMethodPendingMessage_charge" | "PaymentMethodTransactionDetails_charge">;
  readonly " $fragmentType": "PaymentMethodSelectedPending_charge";
};
export type PaymentMethodSelectedPending_charge$key = {
  readonly " $data"?: PaymentMethodSelectedPending_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodSelectedPending_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodSelectedPending_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availablePaymentMethods",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPendingMessage_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodTransactionDetails_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPaymentDeadline_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "e5e8aa7f280f9f33e79f81b87807ab73";

export default node;
